import { Card, KeyValueList, Page, PageHeader } from '@platform/design-system';
import { DataExportPanel, DeletionPanel, useSession } from '@platform/app-kit';
import { PRODUCT_NAME } from '../shell/brand.ts';
import { useDocumentTitle } from '../shell/document-title.ts';

/**
 * `/account` — who the account is, and the person's rights over their data: take a copy of
 * everything we hold, or have it all deleted after 30 days. A personal account is a tenant of
 * one, so the person is its admin and both are theirs to use.
 */
export function AccountPage() {
  const { principal } = useSession();
  useDocumentTitle('Account');
  if (!principal) return null;
  return (
    <Page width="narrow">
      <PageHeader
        title="Account"
        meta={`Your ${PRODUCT_NAME} account. It’s your information: take a copy of it, or have it deleted.`}
      />
      <Card title="You">
        <KeyValueList
          items={[
            { key: 'Name', value: principal.name },
            { key: 'Email', value: principal.email },
          ]}
        />
      </Card>
      <DataExportPanel subject="account" />
      <DeletionPanel subject="account" />
    </Page>
  );
}
